/* eslint-disable react/require-default-props */
/*
 * @Author: steelhouse 
 * @Date: 2018-08-15 15:25:07 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-08-15 16:28:37
 */

import * as React from 'react';
import * as PropTypes from 'prop-types';
import moment from 'moment';

import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';

const styles = {
    labelStyle: { fontSize: '10px' },
    RaisedButtonStyle: { height: '25px', margin: '0 10px 0 0' },
    RaisedButtonButtonStyles: { height: '25px', lineHeight: '25px' },
    DatePickerErrorStyle: { fontSize: '13px', width: '90px', margin: '0 10px 0 0' },
    DatePickerTextFieldStyle: { fontSize: '13px', width: '90px', margin: '0 10px 0 0' },
};

class DateRangeSelector extends React.Component {
    constructor(props) {
        super(props);

        this.setCurrentDate = this.setCurrentDate.bind(this);
        this.setSelectedDate = this.setSelectedDate.bind(this);
        this.setDay = this.setDay.bind(this);
    }

    static propTypes = {
        from: PropTypes.oneOfType([
            PropTypes.instanceOf(Date),
            PropTypes.string,
        ]),
        until: PropTypes.oneOfType([
            PropTypes.instanceOf(Date),
            PropTypes.string,
        ]),

        fromHint: PropTypes.oneOfType([
            PropTypes.instanceOf(Date),
            PropTypes.string,
        ]),
        untilHint: PropTypes.oneOfType([
            PropTypes.instanceOf(Date),
            PropTypes.string,
        ]),
        fromLabel: PropTypes.string,
        untilLabel: PropTypes.string,
        errorFrom: PropTypes.string,
        errorUntil: PropTypes.string,
    };

    /**
     * 
     * @param {Date|undefined} fromDate 
     * @param {Date|undefined} untilDate 
     */
    computeRangeConstraints(fromDate, untilDate) {
        const from = fromDate ? moment.utc(fromDate) : moment.utc();
        const until = untilDate ? moment.utc(untilDate) : moment.utc();

        const minFrom = moment.utc();
        const maxFrom = until;

        const minUntil = moment(from);
        const maxUntil = moment(from).add(2, 'years');

        const disabledRemoveDayFromBtn = moment(from).isSameOrBefore(minFrom, 'days');
        const disabledAddDayFromBtn = moment(from).isSameOrAfter(maxFrom, 'days');

        const disabledRemoveDayUntilFromBtn = moment(until).isSameOrBefore(minUntil, 'days');
        const disabledAddDayUntilBtn = moment(until).isSameOrAfter(maxUntil, 'days');

        return {
            from: from.local(true).toDate(),
            until: until.local(true).toDate(),
            minFrom: minFrom.local(true).toDate(),
            maxFrom: maxFrom.local(true).toDate(),
            minUntil: minUntil.local(true).toDate(),
            maxUntil: maxUntil.local(true).toDate(),
            disabledRemoveDayFromBtn,
            disabledAddDayFromBtn,
            disabledRemoveDayUntilFromBtn,
            disabledAddDayUntilBtn,
        };
    }

    setSelectedDate(date, type) {
        // date picker return selected date in local timezone, so change to utc here
        const inUtc = moment(date).utcOffset(0, true);
        this._changeDate(inUtc, type);
    }

    setCurrentDate(type) {
        const currentDate = moment.utc();

        this._changeDate(currentDate, type);
    }

    setDay(type, direction) {
        const { from, until } = this.props;

        if (!from) {
            return;
        }
        const date = type === 'from' 
            ? moment.utc(from).add(direction, 'days').toDate() 
            : moment.utc(until).add(direction, 'days').toDate();

        this._changeDate(date, type);
    }

    _changeDate(date, type) {
        let { from, until } = this.props;

        if (type === 'from') {
            from = this.onSetFrom(moment.utc(date)).toDate();

            if (moment(from).isAfter(until)) {
                until = this.onSetUntil(moment.utc(from)).toDate();
            }
        } else {
            until = this.onSetUntil(moment.utc(date)).toDate();

            if (moment(from).isAfter(until)) {
                from = this.onSetFrom(moment.utc(until)).toDate();
            }
        }

        this.props.onChange({
            from,
            until,
        });
    }

    /**
     * 
     * @param {moment.Moment} date 
     * @returns {moment.Moment}
     */
    onSetFrom(date) {
        return date.set({
            hours: 0, minutes: 0, seconds: 0, milliseconds: 0, 
        });
    }

    /**
     * 
     * @param {moment.Moment} date 
     * @returns {moment.Moment}
     */
    onSetUntil(date) {
        return date.set({
            hours: 23, minutes: 59, seconds: 59, milliseconds: 999, 
        });
    }

    render() {
        const { 
            from: fromDate,
            until: untilDate,
            fromHint,
            untilHint,
            fromLabel,
            untilLabel,
            errorFrom,
            errorUntil,
        } = this.props;

        const {
            from, until,
            maxFrom, minFrom,
            maxUntil, minUntil,
            disabledAddDayFromBtn, disabledRemoveDayFromBtn,
            disabledAddDayUntilBtn, disabledRemoveDayUntilFromBtn,
        } = this.computeRangeConstraints(fromDate, untilDate);
        
        return (
            <div>
                {
                    fromLabel && (
                        <div className='row'>
                            <div className='column-left'>
                                <div className="label">{ fromLabel }</div>
                            </div>
                        </div>
                    )
                }

                <div>
                    {
                        fromHint ?
                            <span style={{ color: '#f00', fontSize: '12px' }}>
                               Date from clarified {moment(fromHint).format('DD-MM-YYYY')}
                            </span>
                            :
                            ''
                    }
                </div>

                <div className="row full">
                    <RaisedButton
                        labelStyle={styles.labelStyle}
                        style={styles.RaisedButtonStyle}
                        buttonStyle={styles.RaisedButtonButtonStyles}
                        label="Current date"
                        onClick={() => this.setCurrentDate('from')}
                        primary
                    />
                    <RaisedButton
                        labelStyle={styles.labelStyle}
                        style={styles.RaisedButtonStyle}
                        buttonStyle={styles.RaisedButtonButtonStyles}
                        label="-day"
                        onClick={() => this.setDay('from', -1)}
                        primary
                        disabled={disabledRemoveDayFromBtn}
                    />
                    <DatePicker
                        autoOk
                        maxDate={maxFrom}
                        minDate={minFrom}
                        value={from}
                        id="uniqueid"
                        errorText={errorFrom}
                        errorStyle={styles.DatePickerErrorStyle}
                        textFieldStyle={styles.DatePickerTextFieldStyle}
                        onChange={(e, date) => this.setSelectedDate(date, 'from')}
                        formatDate={date => moment(date).format('DD-MM-YYYY')}
                    />
                    <RaisedButton
                        labelStyle={styles.labelStyle}
                        style={styles.RaisedButtonStyle}
                        buttonStyle={styles.RaisedButtonButtonStyles}
                        label="+day"
                        onClick={() => this.setDay('from', 1)}
                        primary
                        disabled={disabledAddDayFromBtn}
                    />
                </div>

                {
                    untilLabel && (
                        <div className='row'>
                            <div className='column-left'>
                                <div className="label">{ untilLabel }</div>
                            </div>
                        </div>
                    )
                }

                <div>
                    {
                        untilHint ?
                            <span style={{ color: '#f00', fontSize: '12px' }}>
                               Date from clarified {moment(untilHint).format('DD-MM-YYYY')}
                            </span>
                            :
                            ''
                    }
                </div>

                <div className="row full">
                    <RaisedButton
                        labelStyle={styles.labelStyle}
                        style={styles.RaisedButtonStyle}
                        buttonStyle={styles.RaisedButtonButtonStyles}
                        label="Current date"
                        onClick={() => this.setCurrentDate('until')}
                        primary
                    />
                    <RaisedButton
                        labelStyle={styles.labelStyle}
                        style={styles.RaisedButtonStyle}
                        buttonStyle={styles.RaisedButtonButtonStyles}
                        onClick={() => this.setDay('until', -1)}
                        label="-day"
                        primary
                        disabled={disabledRemoveDayUntilFromBtn}
                    />
                    <DatePicker
                        autoOk
                        maxDate={maxUntil}
                        minDate={minUntil}
                        value={until}
                        id="uniqueid"
                        errorText={errorUntil}
                        errorStyle={styles.DatePickerErrorStyle}
                        textFieldStyle={styles.DatePickerTextFieldStyle}
                        onChange={(e, date) => this.setSelectedDate(date, 'until')}
                        formatDate={date => moment(date).format('DD-MM-YYYY')}
                    />
                    <RaisedButton
                        labelStyle={styles.labelStyle}
                        style={styles.RaisedButtonStyle}
                        buttonStyle={styles.RaisedButtonButtonStyles}
                        onClick={() => this.setDay('until', 1)}
                        label="+day"
                        primary
                        disabled={disabledAddDayUntilBtn}
                    />
                </div>
            </div>
        );
    }
}

export default DateRangeSelector;



// WEBPACK FOOTER //
// ./app/components/Base/DateRangeSelector/index.js